module.exports = __webpack_public_path__ + "assets/img/star2.e5555c4d.webp";